import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { bindTravelAttachmentsOptions } from '../../../../helpers/ui/blockHelpers';
import AttachmentsStep from '../../../CompensationContainer/Steps/AttachmentsStep';
import { uploadActions } from '../../../../redux/modules/travelClaim';
import useDeviceResize from '../../../../hooks/useDeviceResize';
import {
  getValidationRules,
} from '../../../../helpers/uploadHelpers';
import { ATTACHMENT_MAX_SIZE, ATTACHMENT_TYPES, ATTACHMENT_VALID_MIME_TYPES } from '../../../../constants';

const {
  PASSPORT,
  REFERENCE,
  EPICRISIS,
  EXTRACT_FROM_OUTPATIENT_CARD,
  CASH_REGISTER_RECEIPT,
  DM_CHECK,
  AMOUNT,
  OTHER,
} = ATTACHMENT_TYPES;

const attachmentConstraints = {
  maxSize: ATTACHMENT_MAX_SIZE,
  validMimeTypes: ATTACHMENT_VALID_MIME_TYPES,
  requiredTypes: [
    CASH_REGISTER_RECEIPT,
    PASSPORT,
  ],
  maxNumberLimits: {
    [PASSPORT]: 10,
    [REFERENCE]: 10,
    [EPICRISIS]: 10,
    [EXTRACT_FROM_OUTPATIENT_CARD]: 10,
    [CASH_REGISTER_RECEIPT]: 30,
    [DM_CHECK]: 10,
    [AMOUNT]: 10,
    [OTHER]: 10,
  },
};

const TravelAttachmentsStep = ({
  goNext,
  step,
  goPrevious,
  params: { setStepNavigationBox, scrollTo },
}) => {
  const { attachments } = useSelector((store) => store.travelClaim, shallowEqual);
  const isDeviceLgSize = useDeviceResize('lg');
  const { t } = useTranslation();

  return (
    <AttachmentsStep
      initialData={attachments}
      setStepNavigationBox={setStepNavigationBox}
      loadingProgress={false}
      isDeviceLgSize={isDeviceLgSize}
      goPrevious={goPrevious}
      scrollTo={scrollTo}
      attachments={attachments}
      step={step}
      goNext={goNext}
      uploadActions={uploadActions}
      attachmentConstraints={attachmentConstraints}
      getValidationRules={() => getValidationRules(attachments, attachmentConstraints, PASSPORT)}
      options={bindTravelAttachmentsOptions(t)}
    />
  );
};

TravelAttachmentsStep.propTypes = {
  goNext: PropTypes.func.isRequired,
  step: PropTypes.shape({
    n: PropTypes.number.isRequired,
  }).isRequired,
  goPrevious: PropTypes.func.isRequired,
  params: PropTypes.shape({
    setStepNavigationBox: PropTypes.func.isRequired,
    scrollTo: PropTypes.func.isRequired,
  }).isRequired,
};

export default TravelAttachmentsStep;
